import React from 'react';
import { AdvancedSearch as BetterAdvancedSearch } from './better/advancedSearch';

export function BetterSideNav() {
  return <BetterAdvancedSearch />;
}
